import CommonComponents from '@/components/templates/common'
import { useTemplateContext } from '@/context/TemplateProvider'

import Layout from './personal-website.views'

const PersonalWebsiteHero = () => {
  const { template } = useTemplateContext()

  return (
    <Layout className='select-none pointer-events-none'>
      <Layout.Header>
        <CommonComponents.Wrapper>
          <Layout.Logo>
            {template.logo.src ? (
              <Layout.LogoImage src={template.logo.src} />
            ) : (
              <Layout.LogoText fontFamily={template.logo.fontFamily}>
                {template.logo.text}
              </Layout.LogoText>
            )}
          </Layout.Logo>
        </CommonComponents.Wrapper>
      </Layout.Header>
      <Layout.Hero backgroundImage={template.sections.hero.backgroundImage}>
      <Layout.HeroContainer>
          <CommonComponents.Wrapper>
            <Layout.TitleContainer>
              <Layout.Title variant='h1'>
                {template.sections.hero.title}
              </Layout.Title>
              <Layout.Subtitle variant='subtitle1'>
                {template.sections.hero.subtitle}
              </Layout.Subtitle>
              <Layout.CTA>{template.sections.hero.ctaText}</Layout.CTA>
            </Layout.TitleContainer>
          </CommonComponents.Wrapper>
        </Layout.HeroContainer>
      </Layout.Hero>
    </Layout>
  )
}

export default PersonalWebsiteHero
